// components/AnimatedSlider.jsx
import { motion, AnimatePresence } from "framer-motion";

const variants = {
  enter: (custom) => {
    const { direction, axis } = custom;
    return {
      x: axis === "x" ? (direction > 0 ? 300 : -300) : 0,
      y: axis === "y" ? (1 > 0 ? 300 : -300) : 0,
      opacity: 0,
    };
  },
  center: {
    x: 0,
    y: 0,
    opacity: 1,
  },
  exit: (custom) => {
    const { direction, axis } = custom;
    return {
      x: axis === "x" ? (direction > 0 ? -300 : 300) : 0,
      y: axis === "y" ? (1 > 0 ? -300 : 300) : 0,
      opacity: 0,
    };
  },
};

const AnimatedSlider = ({ children, direction = 1, keyIndex, axis = "x" }) => {
  return (
    <AnimatePresence custom={{ direction, axis }} mode="wait">
      <motion.div
        key={keyIndex}
        custom={{ direction, axis }}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ duration: 0.4 }}
        style={{ width: "100%" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedSlider;
